import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList, TemplateRef } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';

@Component({
    selector: 'app-confirm-popup',
    templateUrl: './confirm-popup.component.html',
    styleUrl: './confirm-popup.component.scss',
    standalone: false
})
export class ConfirmPopupComponent implements AfterContentInit {
  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  @Input() header: string = 'Are you sure?';
  @Input() title: string = '';
  @Input() titleWithUrl: string = '';
  @Input() subTitle?: string = '';
  @Input() subTitle2?: string = '';
  @Input() buttonLabel?: string = 'CONFIRM';
  @Input() buttonLabel2?: string = 'CANCEL';
  @Output() Result = new EventEmitter<ConfirmDialogResult>();
  @ContentChildren(PrimeTemplate) templates: QueryList<PrimeTemplate> | undefined;

  titleTemplate: TemplateRef<any> | undefined;

  ngAfterContentInit(): void {
    this.mapTemplates();
  }

  @Output() isTitleUrlClicked = new EventEmitter<Event>();

  onAction(isConfirm: boolean) {
    const data = {
      success: isConfirm
    }
    this.Result.emit({ data: data });
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }

  onTitleUrlAction(event: Event) {
    this.isTitleUrlClicked.emit(event);
  }

  onHide() {
    this.isVisibleChange.emit(this.isVisible);
  }

  mapTemplates() {
    if (this.templates) {
      (this.templates as QueryList<PrimeTemplate>).forEach(item => {
        switch (item.getType()) {
          case 'title':
            this.titleTemplate = item.template;
            break;
        }
      });
    }
  }

}

export interface ConfirmDialogResult {
  data?: unknown;
}